import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import {
  CreateRoutingPathPayload,
  MachineGroupRoutingPath,
} from "@src/types/namespace-configuration";

export interface CreateRoutingPathResult {
  success: boolean;
  data?: MachineGroupRoutingPath;
  error?: string;
}

export const createRoutingPathUseCase = async (
  payload: CreateRoutingPathPayload,
): Promise<CreateRoutingPathResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const routingPath = await apiUseCases.postCreateRoutingPath(
      namespace,
      payload,
    );

    return {
      success: true,
      data: routingPath,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to create routing path").message,
    };
  }
};
